import { useEffect, useState } from "react";
import SystemModal from "../Common/SystemModal";
import ajaxPurchaseOrders from "../../util/remote/ajaxPurchaseOrders";
import toast, { Toaster } from "react-hot-toast";

const PurchaseOrderDetailsModal = ({ data, org }) => {
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  console.log(data);
  const fetchDetails = async () => {
    if (!data?.purID) return;
    setLoading(true);
    try {
      const server_response =
        await ajaxPurchaseOrders.fetchPurchaseOrderDetails({
          orderID: data.purID,
        });
      if (server_response.status === "OK") {
        setDetails(server_response.details);
      } else {
        toast.error(server_response.message || "Failed to fetch details");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error fetching purchase order details");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDetails();
  }, [data?.id]);

  const orgInfo = {
    name: "LA_PROCURE AFRICA LIMITED",
    lines: [
      "P.O.BOX 28775 KAMPALA",
      "PLOT 79B BOMBO ROAD",
      "TEL: +256701666160",
      "EMAIL: info@laprocure.africa",
    ],
    logoSrc: `${process.env.PUBLIC_URL}/assets/img/brand/icon-light.png`,
    watermarkSrc: `${process.env.PUBLIC_URL}/assets/img/brand/icon-light.png`,
    ...org,
  };

  // Preload images for print
  const preloadImages = async () => {
    const images = [orgInfo.logoSrc, orgInfo.watermarkSrc];
    return Promise.all(
      images.map(
        (src) =>
          new Promise((res) => {
            const img = new Image();
            img.src = src;
            img.onload = res;
            img.onerror = res;
          })
      )
    );
  };

  const Print = async (e) => {
    e.preventDefault();
    await preloadImages();

    const html = document.getElementById("printablediv").innerHTML;
    const w = window.open("", "printWindow");
    w.document.open();
    w.document.write(`
      <html>
        <head>
          <title>Purchase Order</title>
          <style>${baseStyles(orgInfo.watermarkSrc)}</style>
        </head>
        <body>
          ${html}
        </body>
      </html>
    `);
    w.document.close();
    w.focus();
    w.print();
    w.onafterprint = () => w.close();
    w.onfocus = () =>
      setTimeout(() => {
        if (!w.closed) w.close();
      }, 500);
  };

  const RenderFooter = (controls) => (
    <>
      <button
        className="btn ripple btn-dark"
        type="button"
        onClick={controls.close}
      >
        Close
      </button>
      <button className="btn ripple btn-dark" type="button" onClick={Print}>
        Print
      </button>
    </>
  );

  if (loading || !details) return <div>Loading...</div>;

  return (
    <SystemModal
      title="Purchase Order Details"
      id="modal-purchase-order"
      size="xl"
      footer={RenderFooter}
    >
      <Toaster />
      <style>{baseStyles(orgInfo.watermarkSrc)}</style>
      <div id="printablediv">
        <div className="doc">
          <div className="doc-content">
            {/* Header */}
            <div className="doc-header">
              <div className="logo-wrap">
                <img src={orgInfo.logoSrc} alt="Logo" />
              </div>
              <div className="org-text">
                <div className="org-name">{orgInfo.name}</div>
                {orgInfo.lines.map((l, i) => (
                  <div key={i} className="org-line">
                    {l}
                  </div>
                ))}
              </div>
            </div>

            <div className="title">PURCHASE ORDER</div>

            {/* Supplier & PO Info Columns */}
            <div className="po-supplier-info">
              <div className="po-column">
                <div>
                  <b>Supplier:</b>
                </div>
                <div>
                  <b>Contact Person:</b>
                </div>
                <div>
                  <b>Phone:</b>
                </div>
                <div>
                  <b>Email:</b>
                </div>
              </div>
              <div className="po-column">
                <div>{details.supplier.buss_name}</div>
                <div>{details.supplier.contact_person}</div>
                <div>{details.supplier.person_contact}</div>
                <div>{details.supplier.buss_email}</div>
              </div>
              <div className="po-column">
                <div>
                  <b>PO Number:</b>
                </div>
                <div>
                  <b>Date:</b>
                </div>
                <div>
                  <b>Status:</b>
                </div>
              </div>
              <div className="po-column">
                <div>{details.id}</div>
                <div>{details.date_created}</div>
                <div>{details.status === "1" ? "Approved" : "Pending"}</div>
              </div>
            </div>

            {/* Items Table */}
            <table className="items">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Description</th>
                  <th>Unit</th>
                  <th>Qty</th>
                  <th>Unit Price</th>
                  <th>SubTotal</th>
                </tr>
              </thead>
              <tbody>
                {details.items.map((it, idx) => (
                  <tr key={it.id}>
                    <td>{idx + 1}</td>
                    <td>{it.item_name}</td>
                    <td>{it.unit}</td>
                    <td>{it.quantity}</td>
                    <td>{Number(it.cost).toFixed(2)}</td>
                    <td>
                      {(Number(it.cost) * Number(it.quantity)).toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Totals */}
            <table className="totals">
              <tbody>
                <tr>
                  <td>
                    <b>Total Amount</b>
                  </td>
                  <td>{Number(details.total_amount).toFixed(2)}</td>
                </tr>
              </tbody>
            </table>

            {/* Notes */}
            {details.notes && (
              <div className="notes">
                <b>Notes:</b> {details.notes}
              </div>
            )}

            {/* Signature */}
            <div className="signature">
              <div>
                <b>Authorized By:</b>
              </div>
              <div className="line"></div>
            </div>
          </div>

          <div className="footer-print">
            Printed on: {new Date().toLocaleString()}
          </div>
        </div>
      </div>
    </SystemModal>
  );
};

// CSS
const baseStyles = (watermarkSrc) => `
* { box-sizing: border-box; }
body { font-family: Arial, sans-serif; margin: 0; padding: 0; }
.doc {
  position: relative;
  padding: 18mm 15mm;
  min-width: 210mm;
  max-width: 210mm;
  margin: 0 auto;
  background: #fff;
  border: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
.doc::before {
  content: "";
  position: absolute;
  inset: 0;
  background: url("${watermarkSrc}") no-repeat center center !important;
  background-size: 60%;
  opacity: 0.2;
  z-index: 0;
}
.doc-content { flex: 1; display: flex; flex-direction: column; position: relative; z-index: 1; }
.doc-header { display: flex; align-items: center; gap: 16px; margin-bottom: 12px; position: relative; z-index: 2; }
.logo-wrap img { width: 120px; height: 120px; object-fit: contain; }
.org-text { flex: 1; text-align: center; }
.org-name { font-size: 20px; font-weight: 700; letter-spacing: .5px; }
.org-line { font-size: 12px; line-height: 1.2; }
.title { text-align: center; font-size: 18px; font-weight: 700; margin: 12px 0; }

/* Supplier info columns */
.po-supplier-info {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
  gap: 8px;
  margin-bottom: 16px;
}
.po-supplier-info .po-column div {
  margin-bottom: 4px;
  font-size: 13px;
}

table { border-collapse: collapse; width: 100%; margin-top: 10px; }
th, td { border: 1px solid #111; padding: 6px 8px; font-size: 12.5px; vertical-align: top; }
th { background: #f2f2f2; text-align: left; }
.items th:nth-child(4) { width: 60px; }
.totals { margin-top: 16px; width: 260px; float: right; }
.totals td:first-child { width: 60%; }
.signature { margin-top: 30px; }
.signature .line { margin-top: 16px; border-bottom: 1px solid #111; width: 60%; height: 20px; }
.footer-print { margin-top: 18px; font-size: 11px; text-align: right; color: #374151; }
.notes { margin-top: 12px; font-size: 13px; }
@page { size: A4; margin: 12mm; }
`;

export default PurchaseOrderDetailsModal;
